function getErrorMessage(response: any) {
  let errorMsg: string | undefined = undefined
  if (response?.data?.ErrorCode && response.data.DialogBoxes) {
    for (const item of response.data.DialogBoxes) {
      if (item.Layout === "Error") {
        errorMsg = item.Message
      }
    }
  }

  return errorMsg
}

const ajaxEnricher = {
  // Http 20x response
  proccesSuccessMessage(response: any, data: any, action: any) {
    const errorMsg = getErrorMessage(response)
    if (errorMsg) {
      // this scope reserved for error message handling
      return { error: errorMsg }
    } else {
      // this scope reserved for success message handling
      return { data: response.data }
    }
  },
  // Http 50x response
  proccesErrorMessage(error: any, action: any) {
    return error
  }
}

export default ajaxEnricher
